import { render, staticRenderFns } from "./PageRestaurantPreview.vue?vue&type=template&id=45e1e948&scoped=true&"
import script from "./PageRestaurantPreview.vue?vue&type=script&lang=ts&"
export * from "./PageRestaurantPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PageRestaurantPreview.vue?vue&type=style&index=0&id=45e1e948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1e948",
  null
  
)

export default component.exports